import React from 'react'
import { PageHeader, Row, Form, Select, Button, message } from 'antd'
import {
  CREATE_PRODUCT_MODIFIER_GROUPS,
  DELETE_PRODUCT_MODIFIER_GROUPS
} from '../ProductQueries'
import { ModifierGroup, ProductInfo } from '@slerp/controls'
import { useMutation, useApolloClient } from '@apollo/client'
import { Link } from 'react-router-dom'
import { uuid } from 'uuidv4'
import { Store } from 'antd/lib/form/interface'
const { useForm } = Form

interface ModifiersFormProps {
  modifierGroups: Array<ModifierGroup>
  product: ProductInfo
}

const ModifiersForm = (props: ModifiersFormProps) => {
  const { modifierGroups, product } = props
  const productModifierGroupArrangement = Object.values(
    product.modifier_group_arrangement
  )
  const client = useApolloClient()
  const [form] = useForm()

  const [createProductGroupModifier] = useMutation(
    CREATE_PRODUCT_MODIFIER_GROUPS
  )
  const [deleteProductGroupModifier] = useMutation(
    DELETE_PRODUCT_MODIFIER_GROUPS
  )

  const onFinish = (values: Store) => {
    const { modifier_groups } = values
    message.loading('Adding in modifier groups... Please Wait.')
    const data = productModifierGroupArrangement.filter(
      (id: string) => !modifier_groups.includes(id)
    )

    deleteProductGroupModifier({
      variables: {
        productId: product.id,
        modifierGroupId: data
      }
    })
      .then((result) => {
        const values = modifier_groups.map((id: string) => {
          const item = {
            id: uuid(),
            product_id: product.id,
            modifier_group_id: id
          }
          return item
        })

        createProductGroupModifier({
          variables: {
            values: values,
            productId: product.id,
            modifierGroupArrangement: { ...modifier_groups }
          }
        })
          .then((result) => {
            message.destroy()
            client.resetStore()
            message.success('Modifier Group Added!', 1)
          })
          .catch((err) => {
            message.destroy()
            client.resetStore()
            message.error('Unable to add Modifier Group')
          })
      })
      .catch((err) => {
        message.destroy()
        client.resetStore()
        message.error('Unable to remove Modifier Group!', 1)
      })
  }

  return (
    <Form
      data-testid='modifiers-form'
      form={form}
      onFinish={onFinish}
      initialValues={{ modifier_groups: productModifierGroupArrangement }}
    >
      <PageHeader title='Modifiers' style={{ paddingBottom: '0' }} />
      <label>
        Add modifier groups (for example, Sides) and modifier items (for
        example, Fries) to allow your customers to customise their orders.
      </label>

      <Row style={{ margin: '15px 0' }}>
        <Form.Item name='modifier_groups' style={{ width: '100%' }}>
          <Select
            mode='multiple'
            size='large'
            allowClear
            placeholder='Select Modifier Group'
            dropdownClassName='select-multiple'
          >
            {modifierGroups.map(
              ({
                key,
                name,
                description
              }: {
                key: string
                name: String
                description: String
              }) => (
                <Select.Option key={key} value={key}>
                  {name} ({description})
                </Select.Option>
              )
            )}
          </Select>
        </Form.Item>
      </Row>
      <hr
        style={{
          borderColor: '#e8e8e8',
          borderStyle: 'none none solid',
          margin: '24px 0',
          width: '100%'
        }}
      />
      <Row justify='end'>
        <Button size='large' key='cancel' type='text'>
          <Link to='/products'>Cancel</Link>
        </Button>
        <Button size='large' type='primary' htmlType='submit'>
          Save
        </Button>
      </Row>
    </Form>
  )
}

export default ModifiersForm
